import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { rootRoute } from '../../router/routes/rootRoute';

export const profileRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/profile',
	component: lazyRouteComponent(() => import('./ProfilePage'), 'ProfilePage'),
});
